import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateOrganization } from ".";
import { queryKeys } from "../../../../../lib/useQuery/queryKeys";

export function useUpdateOrganization() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: queryKeys.organisation._def,
    mutationFn: updateOrganization,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.organisation._def,
        exact: false,
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.crm._def,
        exact: false,
      });
    },
  });
}
